<template>
  <div class="stat-page">
    <div class="main-wrap">
      <div class="content-row">
        <!-- 左侧整列：筛选器 + 垂直排列统计卡片 -->
        <div class="left-col">
          <!-- 【新增外层flex容器：筛选盒子 和 返回按钮并排】 -->
          <div class="filter-wrap">
            <!-- 时间筛选面板，已删除底部说明文字 -->
            <div class="filter-side">
              <div class="filter-title">按时间范围查询</div>
              <div class="filter-row">
                <div class="filter-item">
                  <select v-model="timeMode" @change="onTimeChange">
                    <option value="all">全部时间</option>
                    <option value="month">选择年月</option>
                  </select>
                </div>
                <div class="filter-item" v-if="timeMode === 'month'">
                <input type="month" v-model="selectMonth" @change="onTimeChange"/>
                </div>
              </div>
            </div>
            <!-- 返回按钮放在整个filter-side盒子的外面右侧 -->
            <button class="back-btn" @click="goProfile">返回</button>
          </div>

          <!-- 三个统计小块【垂直排列】，宽度和筛选器一致 -->
          <div class="stat-card-wrap">
            <div class="stat-item item1">
              <div class="stat-line">
                <span class="stat-num">{{ statData.provinceCount }}</span>
                <span class="stat-text">个 足迹省份</span>
              </div>
              <div class="stat-sub">{{ statData.provinceDetail }}</div>
            </div>
            <div class="stat-item item2">
              <div class="stat-line">
                <span class="stat-num">{{ statData.cityCount }}</span>
                <span class="stat-text">个 足迹城市</span>
              </div>
              <div class="stat-sub">{{ statData.cityDetail }}</div>
            </div>
            <div class="stat-item item3">
              <div class="stat-line">
                <span class="stat-num">{{ statData.travelTimes }}</span>
                <span class="stat-text">条 足迹记录</span>
              </div>
              <div class="stat-sub">{{ statData.travelDetail }}</div>
            </div>
          </div>
        </div>

        <!-- 中间地图区域，满占剩余宽度 -->
        <div class="map-wrap">
          <div class="map-container">
            <FootprintMap
              :footData="footList"
              :groupType="groupType"
              :isLogin="isLogin"
              :provinceStat="provinceCountMap"
              @province-click="handleMapClick"
            />
          </div>
          <!-- 地图左下角小巧TOP3城市条形面板 -->
         <div class="city-chart" ref="cityChartRef">
         <div class="city-chart-title">城市足迹 TOP3</div>
         <div class="city-chart-body" ref="cityChartBody"></div>
         </div>
       </div>

        <!-- 右侧：竖排标题（删掉了里面的返回按钮） -->
        <div class="right-title-box">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FootprintMap from '@/components/FootprintMap.vue'
import { getCurrentUser, getFootprintList, getMyGroupList } from '@/api/footprint'
export default {
  name: 'FootprintStat',
  components: {
    FootprintMap
  },
  data() {
    return {
      rawAllFoot: [],
      filteredFoot: [],
      footList: [],
      groupType: 'lover',
      isLogin: false,
      timeMode: 'all',
      selectMonth: '',
      provinceCountMap: {},
      statData: {
        provinceCount: 0,
        cityCount: 0,
        travelTimes: 0,
        provinceDetail: '',
        cityDetail: '',
        travelDetail: ''
      },
      topCityList: []
    }
  },
  activated() {
    this.loadFootData()
  },
  mounted() {
    this.loadFootData()
  },
  beforeUnmount() {
    // 无echarts实例，清空引用即可
    this.$refs.cityChartBody = null
  },
  methods: {
    // 轻量DOM绘制条形，无任何echarts
   updateCityBars() {
  if (!this.$refs.cityChartBody) return
  const list = this.topCityList || []
  if(list.length === 0) {
    this.$refs.cityChartBody.innerHTML = `<div style="font-size:11px;color:#777">暂无打卡数据</div>`
    return
  }
  const maxCount = Math.max(...list.map(i => i.count))

  let htmlStr = ''
  list.forEach((item, index) => {
    const percent = Math.round((item.count / maxCount) * 100)
    const rankClass = 'rank' + (index + 1)
        htmlStr += `
      <div class="city-row">
        <span class="city-name" title="${item.cityName}">${item.cityName}</span>
        <div class="city-bar-wrap">
          <div class="city-bar ${rankClass}" style="width:${percent}%"></div>
          <span class="city-count">${item.count}</span>
        </div>
      </div>
    `
  })
  this.$refs.cityChartBody.innerHTML = htmlStr
},
  async loadFootData() {
  const user = await getCurrentUser()
  if (!user?.phone) {
    this.isLogin = false
    this.rawAllFoot = []
    this.filteredFoot = []
    this.footList = []
    this.topCityList = []
    this.calcStat()
    return
  }
  this.isLogin = true

  const personalFootList = await getFootprintList('personal')
const myGroups = await getMyGroupList()
let groupFootAll = []
// 和首页index完全一致的映射
const typeList = [
  {name:"恋人伴侣", groupTypeKey:"lover"},
  {name:"亲子眷幼", groupTypeKey:"child"},
  {name:"孝亲伴老", groupTypeKey:"parent"},
  {name:"同事", groupTypeKey:"colleague"},
  {name:"朋友", groupTypeKey:"friend"},
  {name:"亲戚", groupTypeKey:"relative"},
  {name:"同学", groupTypeKey:"classmate"},
]
// 转成键值对，方便快速查找
const subTypeMap = {}
typeList.forEach(item => {
  subTypeMap[item.groupTypeKey] = item.name
})

for (const g of myGroups) {
  const groupFoot = await getFootprintList(g.groupId)
  let showName;
  // 判断：大类是other，才取子类型；否则取groupType
  if(g.groupType === 'other'){
    showName = subTypeMap[g.otherSubType] || '未知小组'
  }else{
    showName = subTypeMap[g.groupType] || '未知小组'
  }
  groupFootAll = groupFootAll.concat(groupFoot.map(item => {
    return {
      ...item,
      groupName: showName
    }
  }))
}
  this.rawAllFoot = [
    ...personalFootList.map(item => ({ ...item, groupName: '个人' })),
    ...groupFootAll
  ]
  this.onTimeChange()
},

    onTimeChange() {
      if(this.timeMode === 'all'){
        this.filteredFoot = [...this.rawAllFoot]
      }else{
        if(!this.selectMonth) return
        const [targetYear, targetMonth] = this.selectMonth.split('-')
        this.filteredFoot = this.rawAllFoot.filter(item => {
          if(!item.arriveTime) return false
          const d = new Date(item.arriveTime)
          const y = String(d.getFullYear())
          const m = String(d.getMonth() +1).padStart(2,'0')
          return y === targetYear && m === targetMonth
        })
      }
      this.calcStat()
    },

    calcStat() {
  const raw = this.filteredFoot
  this.statData.travelTimes = raw.length

  const groupStatMap = {}
  const allProvinceSet = new Set()
  const allCitySet = new Set()
  const provMap = {}
  const cityCountMap = {}
  // ==========新增：按省份存储个人/小组次数，给地图tooltip用==========
  const provinceCountMap = {}

  raw.forEach(record => {
    const gName = record.groupName || '未知'
    if(!groupStatMap[gName]){
      groupStatMap[gName] = {
        provinceSet: new Set(),
        citySet: new Set(),
        travelCount: 0
      }
    }
    groupStatMap[gName].travelCount += 1
    const p = record.province
    const c = record.city
    if(!p || !c) return
    groupStatMap[gName].provinceSet.add(p)
    groupStatMap[gName].citySet.add(c)
    allProvinceSet.add(p)
    allCitySet.add(c)

    if (!provMap[p]) provMap[p] = new Set()
    provMap[p].add(c)

    // 统计每个城市出现次数
    if(!cityCountMap[c]) cityCountMap[c] = 0
    cityCountMap[c] += 1

    // ==========新增：省份次数统计 开始==========
    if (!provinceCountMap[p]) {
      provinceCountMap[p] = {
        personal: 0, //个人打卡次数
        group: 0,    //小组打卡次数
        total: 0
      }
    }
    if(gName === '个人'){
      provinceCountMap[p].personal += 1
    }else{
      provinceCountMap[p].group += 1
    }
    provinceCountMap[p].total = provinceCountMap[p].personal + provinceCountMap[p].group
    // ==========新增：省份次数统计 结束==========
  })

  this.footList = Object.keys(provMap).map(prov => ({
    province: prov,
    cities: Array.from(provMap[prov])
  }))

  // 【把省份统计挂载到this，地图组件可以读取】
  this.provinceCountMap = provinceCountMap

  this.statData.provinceCount = allProvinceSet.size
  this.statData.cityCount = allCitySet.size

  const provParts = []
  const cityParts = []
  const travelParts = []
  Object.keys(groupStatMap).forEach(g => {
    const item = groupStatMap[g]
    provParts.push(`${g}：${item.provinceSet.size}`)
    cityParts.push(`${g}：${item.citySet.size}`)
    travelParts.push(`${g}：${item.travelCount}`)
  })
  this.statData.provinceDetail = provParts.join('、')
  this.statData.cityDetail = cityParts.join('、')
  this.statData.travelDetail = travelParts.join('、')

  // 取出TOP3城市
  const cityArr = Object.keys(cityCountMap).map(cityName=>{
    return {cityName, count: cityCountMap[cityName]}
  })
  cityArr.sort((a,b)=> b.count - a.count)
  this.topCityList = cityArr.slice(0,3)
  this.$nextTick(() => {
    this.updateCityBars()

console.log('provinceCountMap', JSON.parse(JSON.stringify(provinceCountMap)))
  })
},

    handleMapClick(provName) {
      console.log('点击省份：', provName)
    },
    goProfile() {
      this.$router.push({
        path: '/personal-center'
      })
    }
  }
}
</script>

<style scoped>
.stat-page {
  width:100%;
  height: 100vh; /* 改用 100vh 锁定高度 */
  box-sizing: border-box;
  display:flex;
  justify-content:center;
  align-items:center;
  /* 统一全站背景 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
  padding: clamp(8px, 1.5vw, 16px);
}

.main-wrap{
  width:100%;
  max-width:100%;
  height: 100%;
}

.content-row{
  display:flex;
  align-items:flex-start;
  gap: clamp(8px, 1.5vw, 16px);
  width:100%;
  height: 100%;
}

/* 左侧整列容器：筛选器 + 垂直卡片 */
.left-col{
  width: clamp(200px, 22vw, 260px); /* 自适应宽度 */
  flex-shrink: 0;
  display:flex;
  flex-direction:column;
  gap: clamp(10px, 1.5vh, 16px);
  height: 100%;
}

/* 筛选外层容器 */
.filter-wrap {
  display: flex;
  align-items: stretch;
  gap: clamp(8px, 1vw, 12px);
  position: relative;
  z-index: 10; 
}

/* 时间筛选面板：高光琉璃 */
/* 时间筛选面板：高光琉璃 */
/* 时间筛选面板：极致磨砂玻璃 */
.filter-side {
  width: 100%;
  border-radius: 16px;
  padding: clamp(10px, 1.5vw, 16px);
  box-sizing: border-box;
  
  /* 👇 核心：降低透明度让背景透出来，增加磨砂模糊 */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  
  /* 👇 极亮的玻璃边缘 + 内部高光 */
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.06),
    inset 0 1px 3px rgba(255, 255, 255, 1); /* 顶部极亮反光 */
    
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  transition: all 0.25s ease;
}

/* 把里面的下拉框也做成小玻璃片，融入整体 */
.filter-item select, .filter-item input {
  width: 100%;
  height: clamp(28px, 4vh, 34px);
  padding: 0 clamp(6px, 0.8vw, 10px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.5); /* 半透明白 */
  backdrop-filter: blur(4px);
  border-radius: 6px;
  font-size: clamp(12px, 1.2vw, 14px);
  color: #333;
  outline: none;
  transition: all 0.2s ease;
}
.filter-item select:focus, .filter-item input:focus {
  background: rgba(255, 255, 255, 0.8);
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
.filter-side:hover {
  background: rgba(255, 255, 255, 0.55);
  box-shadow: 
    0 10px 28px rgba(0, 0, 0, 0.12), 
    inset 0 1px 3px rgba(255, 255, 255, 1);
}

.filter-title{
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight:bold;
  margin-bottom: clamp(8px, 1.2vh, 12px);
  color:#2c3e50;
}
.filter-row{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
}
.filter-item{
  flex:1;
  min-width:80px;
}
.filter-item label{
  display:block;
  font-size: clamp(11px, 1vw, 13px);
  color:#666;
  margin-bottom:4px;
}
.filter-item select, .filter-item input{
  width:100%;
  height: clamp(28px, 4vh, 34px);
  padding: 0 clamp(6px, 0.8vw, 10px);
  border:1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.6);
  border-radius:6px;
  font-size: clamp(12px, 1.2vw, 14px);
  color: #333;
  outline: none;
}
.filter-item select:focus, .filter-item input:focus {
  border-color: #409eff;
}

/* 统计卡片：垂直排列 */
.stat-card-wrap {
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1vh, 12px);
  width: 100%;
}

.stat-item {
  width: 100%;
  border-radius: 16px; /* 统一大圆角 */
  text-align: center;
  padding: clamp(10px, 1.5vh, 14px) clamp(8px, 1vw, 12px);
  box-sizing: border-box;
  transition: all 0.25s ease;
  
  /* 👇 琉璃通用立体感 */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
}

/* 👇 赋予每个卡片专属的高光微渐变（模拟光线照射） */
.item1 {
  /* 静谧蓝：底色加深，顶部高光 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 50%), 
              rgba(175, 205, 250, 0.9);
}
.item2 {
  /* 抹茶绿：底色加深 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 50%), 
              rgba(195, 230, 180, 0.9);
}
.item3 {
  /* 暖阳橙：底色加深 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 50%), 
              rgba(250, 210, 185, 0.9);
}
/* 👇 悬浮效果：浮起 */
.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 12px 28px rgba(0, 0, 0, 0.12),
    inset 0 1px 3px rgba(255, 255, 255, 0.9);
}
.stat-line {
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.stat-num {
  /* 👇 数字更大、更粗、带一点点内阴影，立体感更强 */
  font-size: clamp(22px, 2.8vw, 30px); 
  font-weight: 900;
  color: #1a2a3a; /* 更深的颜色，压得住底部的浅色 */
  margin-right: 4px;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.8); /* 模拟文字浮雕 */
}
.stat-text {
  font-size: clamp(12px, 1.1vw, 14px);
  color: #555;
  font-weight: 600;
}
.stat-sub {
  font-size: clamp(10px, 1vw, 12px);
  color: #777;
  margin-top: clamp(4px, 0.8vh, 8px);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.map-wrap{
  flex:1 1 auto;
  min-width: 0;
  position:relative;
  height:100%;
  /* 屏幕越大，向右负得越多，为了让出平移后的空间 */
  margin-right: -25vw; 
}
.map-container {
  width: 100%; /* 👈 保持 100% 不变，不要让 Echarts 觉得变宽了 */
  height: 100%;
  /* 👈 仅向左平移 15vw，屏幕越大往左靠得越多 */
  transform: translateX(-25vw); 
}
/* 秀气小巧的左下角条形面板（无卡片背景，悬浮在风景上） */
.city-chart {
  position: absolute;
  left: clamp(10px, 1.5vw, 16px);
  bottom: clamp(10px, 2vh, 20px);
  
  width: clamp(150px, 18vw, 220px); 
  padding: 0; /* 去掉内边距 */
  box-sizing: border-box;
  z-index: 10;
  /* 去掉了所有的背景、边框和模糊 */
}

.city-chart-title {
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: clamp(6px, 1vh, 10px);
  letter-spacing: 0.5px;
  
  /* 👇 核心：文字加上白色发光，保证在复杂背景上绝对清晰 */
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.9), 0 0 6px rgba(255, 255, 255, 0.6);
}

:deep(.city-chart-body) {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vh, 10px);
}

:deep(.city-row) {
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.8vw, 8px);
  height: auto;
}

/* 城市名字自适应 + 发光 */
:deep(.city-name) {
  width: clamp(46px, 5vw, 60px);
  font-size: clamp(10px, 1vw, 12px);
  color: #333;
  font-weight: 600;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.9);
}

:deep(.city-bar-wrap) {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

/* 进度条自适应 */
:deep(.city-bar) {
  height: clamp(6px, 1vh, 10px);
  border-radius: 999px; 
  flex-shrink: 0;
  max-width: calc(100% - 20px);
  /* 👇 加一点白色外发光，让进度条在背景上更亮眼 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 4px rgba(255, 255, 255, 0.5);
}

/* 数字自适应 + 发光 */
:deep(.city-count) {
  font-size: clamp(10px, 1vw, 12px);
  font-weight: 800;
  color: #2c3e50;
  flex-shrink: 0;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.9);
}

/* 前三名的颜色（保持高饱和度） */
:deep(.city-bar.rank1) {
  background: linear-gradient(90deg, #409eff, #79bbff);
}
:deep(.city-bar.rank2) {
  background: linear-gradient(90deg, #67c23a, #95d475);
}
:deep(.city-bar.rank3) {
  background: linear-gradient(90deg, #e6a23c, #eebe77);
}
/* 右侧标题盒子，删掉了里面的返回按钮 */
.right-title-box{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:120px;
  white-space:nowrap;
}
.page-title {
  margin:0;
  font-size: 22px;
  color:#222;
  font-weight:bold;
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing:4px;
}
.back-btn {
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px);
  align-self: flex-start; /* 顶部对齐，不准拉伸 */
  
  border-radius: 6px;
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  
  /* 👇 核心：高光白玉/蓝底琉璃，和其他页面保持绝对一致 */
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}

.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}
</style>